import { countries } from 'countries-list';
import { distinct } from './array/distinct';
import { flatten } from './array/flatten';
import { filterOnlyStrings } from './array/filterOnlyStrings';

export const ZERO_DOLLAR_VALUE = '0.00';

export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;

export const TWO_YEARS_AGO = 63113852000;

export const roles = {
  GAMEDAY_EXTERNAL_ADMIN: 'GAMEDAY_EXTERNAL_ADMIN',
  GAMEDAY_INTERNAL_ADMIN: 'GAMEDAY_INTERNAL_ADMIN',
  GAMEDAY_INVOICE_ONLY: 'GAMEDAY_INVOICE_ONLY',
  GAMEDAY_VIEW_ONLY: 'GAMEDAY_VIEW_ONLY',
  GAMEDAY_PRODUCTION_SUPPORT: 'GAMEDAY_PRODUCTION_SUPPORT',
  GAMEDAY_STANDARD_USER: 'GAMEDAY_STANDARD_USER',
  GAMEDAY_SUPER_USER: 'GAMEDAY_SUPER_USER'
};

export const sortBy = {
  ROLE_DESC: 'roleDesc'
};

export const NA_EMAIL = 'gameday@nike.com';
export const EU_EMAIL = 'gamedayEU@nike.com';
export const CN_EMAIL = 'gamedayGC@nike.com';

export const CONTACT_PHONE_NUMBER = '503-532-0800';

export const isNAUser = country => country === 'US' || country === 'CA';
export const isCNUser = country => country === 'CN';

export const NA_SALES_ORGS = [
  '1000', // US
  '1100', // Canada
  '1020' // MANA
];

export const isNASalesOrg = salesOrg => NA_SALES_ORGS.includes(salesOrg);

export const MANA_SALES_ORG = '1020';

export const US_SALES_ORGS = [
  '1000', // US
  '1020' // MANA
];

export const isUSSalesOrg = salesOrg => US_SALES_ORGS.includes(salesOrg);

export const EU_SALES_ORGS = [
  '2000' // NEON Netherlands
];

export const isEUSalesOrg = salesOrg => EU_SALES_ORGS.includes(salesOrg);

export const CHINA_SALES_ORGS = [
  '9800', // Greater China
  '9600', // Nike Hong Kong
  '9700' // Nike Taiwan
];

export const CHINA_SALES_ORG = '9800';

export const US_SALES_ORG = '1000';

export const HONG_KONG_SALES_ORG = '9600';

export const TAIWAN_SALES_ORG = '9700';

export const AUSTRALIA_SALES_ORGS = ['8700'];

export const JAPAN_SALES_ORGS = '7000';

export const isJapanSalesOrg = salesOrg => JAPAN_SALES_ORGS.includes(salesOrg);

export const INVOICE_HIDDEN_SALES_ORGS = ['9800', '9700', '7000', '8800'];

export const isInvoiceHiddenSalesOrg = salesOrg => INVOICE_HIDDEN_SALES_ORGS.includes(salesOrg);

/**
 * @returns {Array<string>}
 */
export const currencies = filterOnlyStrings(
  distinct(flatten(Object.values(countries).map(({ currency }) => currency.split(','))))
);

export const VIEW_TYPES = { LIST: 'list', GRID: 'grid' };
